export const getItem = item => localStorage.getItem(item);

export const removeItem = item => localStorage.removeItem(item);



// WEBPACK FOOTER //
// ./src/utils/localStorageService.js